export default __webpack_public_path__ + "static/media/trust_2.5987bf8a.png";